import NEWAPI from '../API/newIndex';

export const removeS3File = async (urls) => {
  try {
    const res = await NEWAPI({
      url: `/admin/fileupload/delete_file_s3`,
      method: 'delete',
      data: urls, // axios automatically converts → url[]=…&url[]=…
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const removeAttachedImages = async (url) => {
  try {
    await NEWAPI({ url: `/admin/fileupload/removeAttachedImages?url=${url}`, method: 'delete' });
  } catch (error) {
    console.log(error);
  }
};
